export const OUTBOUND = 'OUTBOUND'
export const INBOUND = 'INBOUND'
